import React from 'react';

import ReferentFormation from '../../components/Communication/ReferentFormation/ReferentFormation.module';

function ReferentFormationView() {
  return (
    <ReferentFormation />
  );
}

export default ReferentFormationView;


